import React, { Component } from 'react';
import BookFinder from './components/BookFinder';
import Footer from '../../components/footer';
import { Helmet } from "react-helmet";

class FindGrumple extends Component {
  render() {
    return (
      <div className="full-height full-width">
        <Helmet>
          <title>Find Grumple | Where to Buy Grumple by Kat Medina</title>
          <meta name="description" content="Find where to buy Grumple - A Tahoe Tale of Kindness by Kat Medina. Search for bookstores, online retailers, and libraries near you." />
        </Helmet>
        <BookFinder />
        <Footer />
      </div>
    );
  }
}

export default FindGrumple;




// WEBPACK FOOTER //
// ./src/pages/findGrumple/index.js